import { defineComponent as _defineComponent } from 'vue'
import { useModal } from 'vue-nice-modal'
import AgreementModal from './AgreementModal.vue'
import { PropType } from 'vue'
import { EnumCourseSignupType } from '@xt/client/enums/course'
import { EnumModalOpStatus } from '@xt/client/enums/messageModalQueue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  id: {
    required: true,
    type: Number
  },
  type: {
    required: true,
    type: String as PropType<EnumCourseSignupType>
  }
},
  setup(__props) {

const props = __props;

const modal = useModal() // hook 在 wrapper 中使用


const onClose = () => {
  modal.resolve({
    status: EnumModalOpStatus.Cancel
  })
  modal.hide()
}

return { __sfc: true,modal, props, onClose, AgreementModal }
}

})